import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchLumInfos, getLumInfosType, updateLumInfosType, getLumInfosProperties, updateLumInfosProperties } from '../../../../../../actions';
import { Card, Dropdown, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import ProjectPlaceholder from '../../../ProjectPlaceholder';
import PropertySwitch from './components/PropertySwitch';
import LumInfoForm from './components/LumInfoForm';
import { LUMINAIRE_INFO } from '../../../../../../utils/constantFeatures';
import { luminaireInfosTypes } from '../../../../../../utils/constantValues.js'
import { Trans, withTranslation } from 'react-i18next';
import { t } from 'i18next';

class LuminaireInfo extends BaseFeature {
    constructor(props) {
        super(props);

        this.state = {
            type: {},
            types: [],
            generalParameters: [
                "LuminaireInfo-0:AdditionalLuminaireInfo",
                "LuminaireInfo-2:AdditionalLuminaireInfo",
                "LuminaireInfo-2:MaxInputPower",
                "LuminaireInfo-2:InitialLuminiousFlux",
                "LuminaireInfo-2:CorrelatedColorTemp",
                "LuminaireInfo-2:ColorRenderingIndex",
                "LuminaireInfo-3:AdditionalLuminaireInfo",
                "LuminaireInfo-3:LightDistributionType",
                "LuminaireInfo-3:LuminaireColor",
                "LuminaireInfo-3:LuminaireWeekOfManufacture",
                "LuminaireInfo-3:LuminaireYearOfManufacture",
                "LuminaireInfo-3:GenerateLuminaireId",
                "LuminaireInfo-3:UseProgrammingDate",
                "LuminaireInfo-4:AdditionalLuminaireInfo",
                "LuminaireInfo-4:LightDistributionType",
                "LuminaireInfo-4:LuminaireColor",
                "LuminaireInfo-4:LuminaireWeekOfManufacture",
                "LuminaireInfo-4:LuminaireYearOfManufacture",
                "LuminaireInfo-4:GenerateLuminaireId",
                "LuminaireInfo-4:UseProgrammingDate",
                "LuminaireInfo-4:LightDistribution",
                "LuminaireInfo-5:AdditionalLuminaireInfo",
                "LuminaireInfo-5:LightDistributionType",
                "LuminaireInfo-5:LuminaireColor",
                "LuminaireInfo-5:LuminaireWeekOfManufacture",
                "LuminaireInfo-5:LuminaireYearOfManufacture",
                "LuminaireInfo-5:GenerateLuminaireId",
                "LuminaireInfo-5:UseProgrammingDate",
                "LuminaireInfo-5:LightDistribution"
            ],
            parameters: [],
            loading: false,
            autoGenId: false,
            autoDate: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    handleChange(propertyName, value) {
        var newParameter = {};

        switch (this.getCorrectPropertyName(propertyName)) {
            case LUMINAIRE_INFO.oemGtin:
            case LUMINAIRE_INFO.oemId:
            case LUMINAIRE_INFO.expectedBallastLifeTime:
            case LUMINAIRE_INFO.internalDriverReferenceTemperature:
            case LUMINAIRE_INFO.expectedLightSourceLifeTime:
                //newParameter = this.props.properties[propertyName];
                //newParameter.value = value;
                this.props.handleChange(propertyName, value);
                break;
            default:
                newParameter = this.props.lumInfosProperties.filter((t) => t.info.name === propertyName)[0];
                newParameter.value = value;
                this.props.updateLumInfosProperties(this.props.project.id, this.props.driver.driverId, [newParameter]);
                break;
        }
        this.handleAutoGenerationProperties(propertyName, value);
    }

    handleAutoGenerationProperties(propertyName, value) {
        if (propertyName.endsWith(':GenerateLuminaireId')) {
            this.setState({ autoGenId: value === "1" ? true : false });
        }
        if (propertyName.endsWith(':UseProgrammingDate')) {
            this.setState({ autoDate: value === "1" ? true : false });
        }
    }

    handleChangeDropdown(e) {
        this.setState({ loading: true });
        this.props.updateLumInfosType(this.props.project.id, this.props.driver.driverId, e.target.name)
            .then(() => {
                this.getAvailablesParameters();
            });
    }

    isOn(properties) {
        var isOn = true;

        properties.forEach((p) => {
            if (p === undefined
                || p.value === undefined
                || p.value === null
                || p.value === '') {
                isOn = false;
            }
        });

        return isOn;
    }

    componentDidMount() {
        this.props.fetchLumInfos(this.props.project.id, this.props.driver.driverId)
            .then(() => {
                const values = this.props.properties[LUMINAIRE_INFO.version].valueMeta.availableValues;

                var types = [];
                // this.props.types.forEach((key, i) => types.push({ key: key, value: values[i] }));
                this.props.types.forEach((key, i) =>
                    types.push({
                        key: key,
                        value: luminaireInfosTypes.find(
                            (luminaireInfoType) => luminaireInfoType.key === key
                        ).value,
                    })
                );

                this.setState({ types: types });

                this.getAvailablesParameters();
            });
    }

    //call to api for update parameters
    getAvailablesParameters() {
        this.props.getLumInfosType(this.props.project.id, this.props.driver.driverId)
            .then(() => {
                this.setState({ type: this.state.types.filter((t) => t.key === this.props.type)[0] });

                this.props.getLumInfosProperties(this.props.project.id, this.props.driver.driverId)
                    .then(() => {
                        this.renderAvailablesParameters();
                    });
            });
    }

    //render of parameters
    renderAvailablesParameters() {
        const parameters = [];

        this.props.lumInfosProperties.forEach((property) => {
            //const value = !isNaN(property.value) ? property.value : property.valueMeta.default
            let type = "number";
            if (this.state.generalParameters.indexOf(property.info.name) === -1) {
                if ((property.info.valueType === 3) || (property.info.valueType === 6)) {       // HEX type is abused in luminfos as text
                    type = "text";
                }
                parameters.push(
                    <LumInfoForm
                        key={property.id}
                        property={property}
                        // title={property.info.name.substr(16).replace(/([A-Z])/g, ' $1') }
                        title={t(property.info.name.substr(16)) }
                        min={property.valueMeta.min}
                        max={property.valueMeta.max}
                        step={1}
                        type={type}
                        handleChange={this.handleChange} />
                );
            }
            this.handleAutoGenerationProperties(property.info.name, property.value);
        });

        this.setState({ parameters: parameters });
        this.setState({ loading: false });
    }

    //render of additional parameters
    renderAdditionalParameters() {

        const expectedBallastLifeTime = this.props.properties[LUMINAIRE_INFO.expectedBallastLifeTime];
        const internalDriverReferenceTemperature = this.props.properties[LUMINAIRE_INFO.internalDriverReferenceTemperature];
        const expectedLightSourceLifeTime = this.props.properties[LUMINAIRE_INFO.expectedLightSourceLifeTime];

        const additionalParameters = [expectedBallastLifeTime, internalDriverReferenceTemperature, expectedLightSourceLifeTime];

        if ((this.props.type === 3 || this.props.type === 4 || this.props.type === 5) && this.isOn(additionalParameters)) {
            return (
                <div>
                    <hr size="1" />

                    <LumInfoForm
                        key={expectedBallastLifeTime.id}
                        property={expectedBallastLifeTime}
                        title={t('Rated_Median_Useful_Life_of_Luminaire')}
                        min={expectedBallastLifeTime.valueMeta.min}
                        max={expectedBallastLifeTime.valueMeta.max}
                        step={1}
                        type={"number"}
                        handleChange={this.handleChange} />
                    <LumInfoForm
                        key={internalDriverReferenceTemperature.id}
                        property={internalDriverReferenceTemperature}
                        title={t('Internal_Control_Gear_Reference_Temperature')}
                        min={internalDriverReferenceTemperature.valueMeta.min}
                        max={internalDriverReferenceTemperature.valueMeta.max}
                        step={1}
                        type={"number"}
                        handleChange={this.handleChange} />
                    <LumInfoForm
                        key={expectedLightSourceLifeTime.id}
                        property={expectedLightSourceLifeTime}
                        title={t('Rated_Median_Useful_Light_Source_Starts')}
                        min={expectedLightSourceLifeTime.valueMeta.min}
                        max={expectedLightSourceLifeTime.valueMeta.max}
                        step={0.1}
                        type={"number"}
                        handleChange={this.handleChange} />
                </div>
            );
        }
    }

    renderDropdownItems() {
        let dropdownItems = [];

        // OLD broken way relying on API order
        // const values = this.props.properties[LUMINAIRE_INFO.version].valueMeta.availableValues;

        // this.props.types.forEach((key, i) => {
        //     dropdownItems.push(
        //         <Dropdown.Item onClick={this.handleChangeDropdown} name={key} key={key} >
        //             {values[i]}
        //         </Dropdown.Item>
        //     );
        // });

        this.state.types.forEach((item, i) => {
            dropdownItems.push(
                <Dropdown.Item onClick={this.handleChangeDropdown} name={item.key} key={item.key} >
                    {item.value}
                </Dropdown.Item>
            );
        });

        return dropdownItems;
    }

    //render of general parameters
    renderGeneralParameters() {
        const { t } = this.props;

        const additionalLumInfo = this.props.lumInfosProperties.filter((p) => p.info.name.includes("AdditionalLuminaireInfo"))[0];
        const maxInputPower = this.props.lumInfosProperties.filter((p) => p.info.name.includes("MaxInputPower"))[0];
        const initialLuminiousFlux = this.props.lumInfosProperties.filter((p) => p.info.name.includes("InitialLuminiousFlux"))[0];
        const correlatedColorTemp = this.props.lumInfosProperties.filter((p) => p.info.name.includes("CorrelatedColorTemp"))[0];
        const colorRenderingIndex = this.props.lumInfosProperties.filter((p) => p.info.name.includes("ColorRenderingIndex"))[0];
        const lightDistributionType = this.props.lumInfosProperties.filter((p) => p.info.name.includes("LightDistributionType"))[0];

        const lightDistribution = this.props.lumInfosProperties.filter((p) => p.info.name === "LuminaireInfo-4:LightDistribution")[0];
        const lightDistribution5 = this.props.lumInfosProperties.filter((p) => p.info.name === "LuminaireInfo-5:LightDistribution")[0];
        const luminaireColor = this.props.lumInfosProperties.filter((p) => p.info.name.includes("LuminaireColor"))[0];
        const luminaireWeekOfManufacture = this.props.lumInfosProperties.filter((p) => p.info.name.includes("LuminaireWeekOfManufacture"))[0];
        const luminaireYearOfManufacture = this.props.lumInfosProperties.filter((p) => p.info.name.includes("LuminaireYearOfManufacture"))[0];
        const generateLuminaireId = this.props.lumInfosProperties.filter((p) => p.info.name.includes("GenerateLuminaireId"))[0];
        const useProgrammingDate = this.props.lumInfosProperties.filter((p) => p.info.name.includes("UseProgrammingDate"))[0];

        //switch based on this.props.type for type 2 and type 3 etc.
        switch (this.props.type) {
            case 0:
                return (
                    <LumInfoForm
                        key={additionalLumInfo.id}
                        property={additionalLumInfo}
                        title={t('Additional_luminaire_information')}
                        maxLength="60"
                        isHex={true}
                        type={"text"}
                        handleChange={this.handleChange} />
                );
            case 2:
                return (
                    <div>
                        <LumInfoForm
                            key={additionalLumInfo.id}
                            property={additionalLumInfo}
                            title={t('Additional_luminaire_information') + ' (' + t('max') + ` ${additionalLumInfo.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={additionalLumInfo.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={maxInputPower.id}
                            property={maxInputPower}
                            title={t('Maximum_nominal_input_power')}
                            min={maxInputPower.valueMeta.min}
                            max={maxInputPower.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={initialLuminiousFlux.id}
                            property={initialLuminiousFlux}
                            title={t('Initial_luminous_flux')}
                            min={initialLuminiousFlux.valueMeta.min}
                            max={initialLuminiousFlux.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={correlatedColorTemp.id}
                            property={correlatedColorTemp}
                            title={t('Correlated_color_temperature')}
                            min={correlatedColorTemp.valueMeta.min}
                            max={correlatedColorTemp.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={colorRenderingIndex.id}
                            property={colorRenderingIndex}
                            title={t('Color_rendering_index')}
                            min={colorRenderingIndex.valueMeta.min}
                            max={colorRenderingIndex.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                    </div>
                );
            case 3:
                return (
                    <div>
                        <PropertySwitch
                            property={generateLuminaireId}
                            title={t("Generate_unique_number_per_driver")}
                            className={'enable-generateLuminaireId'}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={additionalLumInfo.id}
                            property={additionalLumInfo}
                            title={t('Additional_luminaire_information') + ' (' + t('max') + ` ${additionalLumInfo.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={additionalLumInfo.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireColor.id}
                            property={luminaireColor}
                            title={t('Luminaire_color') + ' (' + t('max') + ` ${luminaireColor.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={luminaireColor.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={lightDistributionType.id}
                            property={lightDistributionType}
                            title={t('Light_distribution_type')}
                            min={lightDistributionType.valueMeta.min}
                            max={lightDistributionType.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireWeekOfManufacture.id}
                            property={luminaireWeekOfManufacture}
                            title={t('Week')}
                            min={luminaireWeekOfManufacture.valueMeta.min}
                            max={luminaireWeekOfManufacture.valueMeta.max}
                            step={1}
                            type={"number"}
                            auto={this.state.autoDate}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireYearOfManufacture.id}
                            property={luminaireYearOfManufacture}
                            title={t('Year')}
                            min={luminaireYearOfManufacture.valueMeta.min}
                            max={luminaireYearOfManufacture.valueMeta.max}
                            step={1}
                            type={"number"}
                            auto={this.state.autoDate}
                            handleChange={this.handleChange} />
                        <PropertySwitch
                            property={useProgrammingDate}
                            title={t("Use_programming_date")}
                            className={'enable-useProgrammingDate'}
                            handleChange={this.handleChange} />
                    </div>
                );
            case 4:
                return (
                    <div>
                        <PropertySwitch
                            property={generateLuminaireId}
                            title={t("Generate_unique_number_per_driver")}
                            className={'enable-generateLuminaireId'}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={additionalLumInfo.id}
                            property={additionalLumInfo}
                            title={t('Additional_luminaire_information') + ' (' + t('max') + ` ${additionalLumInfo.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={additionalLumInfo.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireColor.id}
                            property={luminaireColor}
                            title={t('Luminaire_color') + ' (' + t('max') + ` ${luminaireColor.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={luminaireColor.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={lightDistributionType.id}
                            property={lightDistributionType}
                            title={t('Light_distribution_type')}
                            min={lightDistributionType.valueMeta.min}
                            max={lightDistributionType.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={lightDistribution.id}
                            property={lightDistribution}
                            title={t('Light_Distribution')}
                            maxLength={lightDistribution.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireWeekOfManufacture.id}
                            property={luminaireWeekOfManufacture}
                            title={t('Week')}
                            min={luminaireWeekOfManufacture.valueMeta.min}
                            max={luminaireWeekOfManufacture.valueMeta.max}
                            step={1}
                            type={"number"}
                            auto={this.state.autoDate}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireYearOfManufacture.id}
                            property={luminaireYearOfManufacture}
                            title={t('Year')}
                            min={luminaireYearOfManufacture.valueMeta.min}
                            max={luminaireYearOfManufacture.valueMeta.max}
                            step={1}
                            type={"number"}
                            auto={this.state.autoDate}
                            handleChange={this.handleChange} />
                        <PropertySwitch
                            property={useProgrammingDate}
                            title={t("Use_programming_date")}
                            className={'enable-useProgrammingDate'}
                            handleChange={this.handleChange} />
                    </div>
                );
            case 5:
                return (
                    <div>
                        <PropertySwitch
                            property={generateLuminaireId}
                            title={t("Generate_unique_number_per_driver")}
                            className={'enable-generateLuminaireId'}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={additionalLumInfo.id}
                            property={additionalLumInfo}
                            title={t('Additional_luminaire_information') + ' (' + t('max') + ` ${additionalLumInfo.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={additionalLumInfo.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireColor.id}
                            property={luminaireColor}
                            title={t('Luminaire_color') + ' (' + t('max') + ` ${luminaireColor.valueMeta.length} ` + t('chars') + ')'}
                            maxLength={luminaireColor.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={lightDistributionType.id}
                            property={lightDistributionType}
                            title={t('Light_distribution_type')}
                            min={lightDistributionType.valueMeta.min}
                            max={lightDistributionType.valueMeta.max}
                            step={1}
                            type={"number"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={lightDistribution5.id}
                            property={lightDistribution5}
                            title={t('Light_Distribution')}
                            maxLength={lightDistribution5.valueMeta.length}
                            isHex={true}
                            type={"text"}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireWeekOfManufacture.id}
                            property={luminaireWeekOfManufacture}
                            title={t('Week')}
                            min={luminaireWeekOfManufacture.valueMeta.min}
                            max={luminaireWeekOfManufacture.valueMeta.max}
                            step={1}
                            type={"number"}
                            auto={this.state.autoDate}
                            handleChange={this.handleChange} />
                        <LumInfoForm
                            key={luminaireYearOfManufacture.id}
                            property={luminaireYearOfManufacture}
                            title={t('Year')}
                            min={luminaireYearOfManufacture.valueMeta.min}
                            max={luminaireYearOfManufacture.valueMeta.max}
                            step={1}
                            type={"number"}
                            auto={this.state.autoDate}
                            handleChange={this.handleChange} />
                        <PropertySwitch
                            property={useProgrammingDate}
                            title={t("Use_programming_date")}
                            className={'enable-useProgrammingDate'}
                            handleChange={this.handleChange} />
                    </div>
                );
            default:
                break;
        }
    }

    render() {

        if (!this.props.types || !this.props.lumInfosProperties || this.state.loading) {
            return (<ProjectPlaceholder />);
        }

        //const infCon = this.props.properties[LUMINAIRE_INFO.content];
        //const infVer = this.props.properties[LUMINAIRE_INFO.version];
        const infOemg = this.props.properties[LUMINAIRE_INFO.oemGtin];
        const infOemid = this.props.properties[LUMINAIRE_INFO.oemId];

        let classNameGeneral = 'card-feature-component';
        let classNameParameters = 'card-feature-component';

        switch (this.props.lumInfosProperties.length) {
            case 0:
                classNameGeneral += ' card-none';
                classNameParameters += ' card-none';
                break;
            case 1:
                classNameParameters += ' card-none';
                break;
            default:
                break;
        }

        return (
            <div>
                <div className="flex-row">
                    <Row>
                        <Col sm={12} md={12} lg={12} style={{marginBottom: '20px', minWidth: '200px'}} >
                            <Card className="card-feature-component" style={{ width: '100%', height: '100%'}}>
                                <div className="card-header-feature">
                                    {<Trans i18nKey="Content_Format_ID" />}
                                </div>
                                <Card.Body className="card-body-feature" >
                                    <Dropdown>
                                        <Dropdown.Toggle variant="secondary" style={{ marginLeft: "0" }} className={"edit-icon-project-header dropdown-osram"}>{this.state.type.value}</Dropdown.Toggle>
                                        <Dropdown.Menu style={{ minWidth: "auto", fontSize: "1rem" }}>
                                            {this.renderDropdownItems()}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <div className="flex-row">
                    <Row>
                        <Col sm={12} md={6} lg={6} style={{marginBottom: '20px', minWidth: '200px'}} >
                            <Card className={classNameGeneral} style={{ width: '100%', height: '100%'}}>
                                <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                                    {<Trans i18nKey="General" />}
                                </div>
                                <Card.Body className={"card-body-feature"} style={{ paddingTop: '0.75rem' }}>
                                    <LumInfoForm
                                        property={infOemg}
                                        title={<Trans i18nKey="GTIN" />}
                                        type={"number"}
                                        key={infOemg.id}
                                        min={infOemg.valueMeta.min}
                                        max={infOemg.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                    <LumInfoForm
                                        property={infOemid}
                                        title={<Trans i18nKey="Identification_Number" />}
                                        type={"number64"}
                                        key={infOemid.id}
                                        min={infOemid.valueMeta.min}
                                        max={infOemid.valueMeta.max}
                                        step={1}
                                        auto={this.state.autoGenId}
                                        handleChange={this.handleChange} />

                                    {this.renderGeneralParameters()}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col sm={12} md={6} lg={6} style={{marginBottom: '20px', minWidth: '200px'}} >
                            <Card className={classNameParameters} style={{ width: '100%', height: '100%'}}>
                                <div className="card-header-feature">
                                    {<Trans i18nKey="Parameters" />}
                                </div>
                                <Card.Body className={"card-body-feature"} style={{ paddingTop: '0.75rem' }}>
                                    {this.state.parameters}

                                    {this.renderAdditionalParameters()}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        validationSummary: state.project.validationSummary,
        type: state.lumInfos.type,
        types: state.lumInfos.types,
        lumInfosProperties: state.lumInfos.lumInfosProperties
    };
};

const mapDispatchToProps = {
    fetchLumInfos,
    getLumInfosType,
    updateLumInfosType,
    getLumInfosProperties,
    updateLumInfosProperties
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(LuminaireInfo);
